var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAdditem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43 16.75c-2.69 0-4.18-1.48-4.18-4.18V5.43c0-2.69 1.48-4.18 4.18-4.18H10c2.69 0 4.18 1.48 4.18 4.18 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-1.88-.8-2.68-2.68-2.68H5.43c-1.88 0-2.68.8-2.68 2.68v7.14c0 1.88.8 2.68 2.68 2.68H8c.41 0 .75.34.75.75s-.34.75-.75.75H5.43z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.75c-2.69 0-4.18-1.48-4.18-4.18v-7.14c0-2.69 1.48-4.18 4.18-4.18h4.57c2.69 0 4.18 1.48 4.18 4.18v7.14c0 2.7-1.48 4.18-4.18 4.18H14zm-2.68-11.32v7.14c0 1.88.8 2.68 2.68 2.68h4.57c1.88 0 2.68-.8 2.68-2.68v-7.14c0-1.88-.8-2.68-2.68-2.68H14c-1.88 0-2.68.8-2.68 2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.88 15.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.25c.41 0 .75.34.75.75s-.34.75-.75.75h-3.25z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.63v-3.25c0-.41.34-.75.75-.75s.75.34.75.75v3.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAdditem);
export default __webpack_public_path__ + "static/media/vuesax-outline-additem.30fbca47df46710c9ffd0b1c33ffa269.svg";
export { ForwardRef as ReactComponent };